module.exports = __webpack_public_path__ + "img/anthemis.e79655f1.jpg";